import { DATA_STATE_COMPLETED, DATA_STATE_CURRENT, DATA_STATE_SELECTED, } from '../../../../constants';
import { getFontWeight as getGlobalFontWeight } from './global';
export function getFontWeight(transformer) {
    const globalFontWeight = getGlobalFontWeight(transformer);
    // Values are only reflected for Calibri font family. For other font families the transformer defines it.
    return Object.freeze({
        button: globalFontWeight.bold,
        heading: globalFontWeight.bold,
        currency: {
            s: {
                default: globalFontWeight.normal,
                attentional: globalFontWeight.bold,
            },
            m: globalFontWeight.bold,
            l: globalFontWeight.bold,
        },
        term: globalFontWeight.bold,
        body: globalFontWeight.normal,
        form: {
            label: globalFontWeight.bold,
            characterInput: globalFontWeight.bold,
            datepicker: {
                date: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: globalFontWeight.bold,
                    },
                },
            },
        },
        listItem: {
            term: globalFontWeight.bold,
            attentional: globalFontWeight.bold,
            description: {
                l: globalFontWeight.bold,
                xl: globalFontWeight.bold,
            },
        },
        strongImportance: globalFontWeight.bold,
        link: {
            strong: globalFontWeight.bold,
        },
        stepIndicator: {
            label: {
                default: globalFontWeight.normal,
                dataStates: {
                    [DATA_STATE_CURRENT]: globalFontWeight.bold,
                    [DATA_STATE_COMPLETED]: globalFontWeight.normal,
                },
            },
        },
        tab: globalFontWeight.bold,
    });
}
